class Imovel {
	constructor() {
	}
}

export default Imovel;